import { render, staticRenderFns } from "./DataSet.vue?vue&type=template&id=1d17ff76&lang=pug"
import script from "./DataSet.vue?vue&type=script&lang=js"
export * from "./DataSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports